import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  EventCard,
  EventTitle,
  EventHour,
  EventLocation,
  EventHourLabel,
  EventHourWrapper,
  EventLabelHourWrapper,
} from './styles';
import { formatDate } from '../../../../lib/utils';

const EventListItem = ({ event }) => {
  const [t] = useTranslation();
  const { 
    original, locale, isMultiDay, title, allDay,
  } = event;

  const formatHour = locale === 'pt' ? 'HH:mm' : 'hh:mm a';
  const formattedDate = 'MMMM/DD/YYYY';

  const videoConferencing = useMemo(() => {
    if (original.video_conferencing?.length) {
      return original.video_conferencing[0].url;
    }

    return null;
  }, [original]);

  const renderEventHour = () => {
    if (isMultiDay) {
      return (
        <div>
          <EventHourWrapper>
            <EventHourLabel>
              {formatDate(
                original.started_at,
                `${formattedDate} ${formatHour}`,
                locale,
              )}
              {' '}
              -
            </EventHourLabel>
            <EventHourLabel>
              {formatDate(
                original.finished_at,
                `${formattedDate} ${formatHour}`,
                locale,
              )}
            </EventHourLabel>
          </EventHourWrapper>
          <EventLabelHourWrapper>
            <EventHourLabel>{t('calendar_events:MULTIPLE_DAY')}</EventHourLabel>
          </EventLabelHourWrapper>
        </div>
      );
    }

    if (!allDay) {
      return (
        <EventHourLabel>
          {formatDate(original.started_at, `${formatHour}`, locale)}
          {' - '}
          {formatDate(original.finished_at, `${formatHour}`, locale)}
        </EventHourLabel>
      );
    }

    return <EventHourLabel>{t('calendar_events:ALL_DAY')}</EventHourLabel>;
  };

  return (
    <EventCard>
      <EventTitle
        isAllDay={allDay !== ''}
        isMultiDay={isMultiDay}
        color={original.eventColor}
      >
        {title}
      </EventTitle>
      <EventHour>{renderEventHour()}</EventHour>
      <EventHour style={{ fontStyle: 'italic' }}>
        {original.humanReadableRecurrence}
      </EventHour>
      <EventLocation>
        {videoConferencing || original.location || ''}
      </EventLocation>
    </EventCard>
  );
};

export default EventListItem;
